export const ADMIN_ADVERTISEMENT_PATH = "/admin/advertisement";
export const ADMIN_ADVERTISEMENT_RESOURCE_PATH = "/admin/advertisement/resources";
export const ADMIN_ADVERTISEMENT_RESOURCE_DETAIL_PATH = "/admin/advertisement/resources/:id";
export const ADMIN_ADVERTISEMENT_GENERATE_PATH = "/admin/advertisement/generate";
export const ADMIN_ADVERTISEMENT_IPHONE_BACKGROUND_PATH =
    "/admin/advertisement/iphone-background";
export const ADMIN_ADVERTISEMENT_PC_BACKGROUND_PATH =
    "/admin/advertisement/pc-background";

export function iphoneBackgroundCropPath(storyId) {
    const id = typeof storyId === "string" ? storyId.trim() : "";
    if (!id) return ADMIN_ADVERTISEMENT_IPHONE_BACKGROUND_PATH;
    return `${ADMIN_ADVERTISEMENT_IPHONE_BACKGROUND_PATH}?storyId=${encodeURIComponent(id)}`;
}

export function pcBackgroundCropPath(storyId) {
    const id = typeof storyId === "string" ? storyId.trim() : "";
    if (!id) return ADMIN_ADVERTISEMENT_PC_BACKGROUND_PATH;
    return `${ADMIN_ADVERTISEMENT_PC_BACKGROUND_PATH}?storyId=${encodeURIComponent(id)}`;
}
/** @deprecated Use {@link ADMIN_ADVERTISEMENT_GENERATE_PATH}. */
export const ADMIN_ADVERTISEMENT_APP_ICON_PATH = ADMIN_ADVERTISEMENT_GENERATE_PATH;
/** @deprecated Use {@link ADMIN_ADVERTISEMENT_GENERATE_PATH}. */
export const ADMIN_ADVERTISEMENT_FEATURE_GRAPHIC_PATH = ADMIN_ADVERTISEMENT_GENERATE_PATH;
/** @deprecated Use {@link ADMIN_ADVERTISEMENT_GENERATE_PATH}. */
export const ADMIN_ADVERTISEMENT_SLIDING_FEATURE_GRAPHIC_PATH = ADMIN_ADVERTISEMENT_GENERATE_PATH;
export const ADMIN_ADVERTISEMENT_APP_SCREENSHOT_LINKS_PATH =
    "/admin/advertisement/app-screenshot-links";
export const ADMIN_AD_SOCIAL_PATH = "/admin/advertisement/social";
export const ADMIN_AD_SOCIAL_FACEBOOK_PATH = "/admin/advertisement/social/facebook";
export const ADMIN_AD_SOCIAL_INSTAGRAM_PATH = "/admin/advertisement/social/instagram";
export const ADMIN_AD_SOCIAL_WORD_WHEEL_PATH = "/admin/advertisement/social/word-wheel";
export const ADMIN_AD_SOCIAL_WORD_WHEEL_GRID_PATH = "/admin/advertisement/social/word-wheel-grid";
export const ADMIN_ADVERTISEMENT_TUTORS_PATH = "/admin/advertisement/tutors";
export const ADMIN_ADVERTISEMENT_PRODUCT_ICON_PATH = "/admin/advertisement/product-icon";
export const ADMIN_ADVERTISEMENT_PROMOTION_PATH = "/admin/advertisement/promotion";
export const ADMIN_ADVERTISEMENT_PROMOTION_NEW_PATH = "/admin/advertisement/promotion/new";
export const ADMIN_ADVERTISEMENT_PROMOTION_EDIT_PATH = "/admin/advertisement/promotion/:code";

export function promotionEditPath(code) {
    return `/admin/advertisement/promotion/${encodeURIComponent(code)}`;
}

export const ADMIN_ADVERTISEMENT_WEEKLY_TEMPLATE_PATH = "/admin/advertisement/weekly/template";
export const ADMIN_ADVERTISEMENT_WEEKLY_ISSUE_PATH = "/admin/advertisement/weekly/:id";

export function weeklyIssuePath(id) {
    const key = typeof id === "string" ? id.trim() : "";
    return `/admin/advertisement/weekly/${encodeURIComponent(key)}`;
}
/** @deprecated Use {@link ADMIN_ADVERTISEMENT_PRODUCT_ICON_PATH}. */
export const ADMIN_ADVERTISEMENT_STRIPE_IMAGE_PATH = "/admin/advertisement/stripe-image";
export const ADMIN_ADVERTISEMENT_APP_SCREENSHOT_GALLERY_PATH =
    "/admin/advertisement/app-screenshot-links/all/:app";
export const ADMIN_ADVERTISEMENT_GOOGLE_AD_PATH =
    "/admin/advertisement/app-screenshot-links/google-ad/:app";
export const ADMIN_ADVERTISEMENT_FACEBOOK_AD_PATH =
    "/admin/advertisement/app-screenshot-links/facebook-ad/:app";
export const ADMIN_ADVERTISEMENT_AMAZON_TABLET_PATH =
    "/admin/advertisement/app-screenshot-links/amazon/:app";

/** Company / studio logo capture — 512×512 SVG. */
export const COMPANY_LOGO_PATH = "/ad/company-logo";

/** Google Play developer header image — 4096×2304 (under construction). */
export const COMPANY_GOOGLE_HEADER_PATH = "/ad/company-google-header";

/** Google AdMob company creatives — landscape 1200×628 + square 1200×1200. */
export const COMPANY_GOOGLE_ADMOB_PATH = "/ad/company-google-admob";

/** Facebook Page cover — 1640×624. */
export const COMPANY_FACEBOOK_COVER_PATH = "/ad/company-facebook-cover";

/** YouTube channel cover / art — 2560×1440. */
export const COMPANY_YOUTUBE_COVER_PATH = "/ad/company-youtube-cover";

/** Stripe dashboard product images — 512×512 icons. */
export const STRIPE_PRODUCT_ICONS_PATH = ADMIN_ADVERTISEMENT_PRODUCT_ICON_PATH;

/** Google AdMob — Jigsaw Muse (landscape, square, 320×50 banner). */
export const JIGSAW_GOOGLE_ADMOB_PATH = "/ad/jigsaw-muse-google-admob";

/** Google AdMob — Word Wheel Quest (landscape, square, 320×50 banner). */
export const WORD_WHEEL_GOOGLE_ADMOB_PATH = "/ad/word-wheel-quest-google-admob";

/** Google AdMob — Sliding Puzzle Quest (landscape, square, 320×50 banner). */
export const SLIDING_GOOGLE_ADMOB_PATH = "/ad/sliding-puzzle-quest-google-admob";

export function advertisementScreenshotGalleryPath(app) {
    return `/admin/advertisement/app-screenshot-links/all/${encodeURIComponent(app)}`;
}

export function advertisementGoogleAdPath(app) {
    return `/admin/advertisement/app-screenshot-links/google-ad/${encodeURIComponent(app)}`;
}

export function advertisementFacebookAdPath(app) {
    return `/admin/advertisement/app-screenshot-links/facebook-ad/${encodeURIComponent(app)}`;
}

export function advertisementAmazonTabletPath(app) {
    return `/admin/advertisement/app-screenshot-links/amazon/${encodeURIComponent(app)}`;
}

export function advertisementResourceDetailPath(id) {
    return `/admin/advertisement/resources/${encodeURIComponent(id)}`;
}

/** Web Google Ads capture frames — landscape / square game + tutor shots. */
export const WEB_GOOGLE_AD_PATH = "/ad/web-google-ads";

export function webGoogleAdPath(asset, shot) {
    const key = typeof asset === "string" ? asset.trim() : "";
    const shotKey = typeof shot === "string" ? shot.trim() : "";
    if (!key) {
        return WEB_GOOGLE_AD_PATH;
    }
    const params = new URLSearchParams();
    params.set("asset", key);
    if (shotKey) {
        params.set("shot", shotKey);
    }
    return `${WEB_GOOGLE_AD_PATH}?${params.toString()}`;
}

/** Generate Media page; optional resourceType preselects the type dropdown. */
export function advertisementGeneratePath(resourceType) {
    const type = typeof resourceType === "string" ? resourceType.trim() : "";
    if (!type) {
        return ADMIN_ADVERTISEMENT_GENERATE_PATH;
    }
    return `${ADMIN_ADVERTISEMENT_GENERATE_PATH}?resourceType=${encodeURIComponent(type)}`;
}
